class BackToTopBtn extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
  }

  connectedCallback() {
    this.button?.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}

customElements.define('back-to-top-btn', BackToTopBtn);

class CustomFooter extends HTMLElement {
  constructor() {
    super();

    this.submitBtn = this.querySelector('form button');
    this.tempBtn = this.querySelector('.footer__newsletter-form--tempBtn');

    if (this.submitBtn && this.submitBtn.hasAttribute('disabled')) {
      document.documentElement.removeAttribute('scroll-lock');
      this.submitBtn.classList.add('hidden');
      this.tempBtn?.classList.remove('hidden');

      setTimeout(() => {
        document.documentElement.removeAttribute('scroll-lock');
      }, 300);

      setTimeout(() => {
        this.submitBtn?.classList.remove('hidden');
        this.tempBtn?.classList.add('hidden');
        this.submitBtn?.removeAttribute('disabled');
      }, 10000);
    }
  }
}

customElements.define('custom-footer', CustomFooter);
